import { createFileRoute } from "@tanstack/react-router";

import { CrmProfilesPage } from "../crm_profiles/CrmProfilesPage";
import { crmAdvisorSignalsQueryOptions } from "../crm_profiles/queries";

export const Route = createFileRoute("/_auth/crm-profiles/")({
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(crmAdvisorSignalsQueryOptions)
      .catch(() => undefined),
  component: CrmProfilesPage,
});
